import React, { useEffect, useState } from "react";
import { PieChart, Pie, Cell, Legend, Tooltip, ResponsiveContainer } from "recharts";

const PieChartGraph = ({ obj }: any) => {
  const [data, setData] = useState<any>([]);
  const localData = localStorage.getItem("userdata") ||JSON.stringify({accessCode:""}) ;
  const access_code = JSON.parse(localData).accessCode ;
  function convertActivityToArray(activity: any) {
    const result = [];

    for (const [key, value] of Object.entries(activity)) {
      let name = "";
      switch (key) {
        case "usersTakingSessions":
          name = `${access_code? "Employees":"Users"} taking sessions`;
          break;
        case "usersEngagingWithChatBot":
          name = `${access_code? "Employees":"Users"} engaging with ChatBot`;
          break;
        case "userTakingAssessments":
          name = `${access_code? "Employees":"Users"} taking assessments`;
          break;
      }
      result.push({ name, value: value as number });
    }
    setData(result);
  }

  const isNoData = data.every((entry: any) => entry.value === 0);

  const COLORS = ["#0088FE", "#00C49F", "#FFBB28"];
  useEffect(() => {
    convertActivityToArray(obj)
  }, [obj])

  return (
    <div style={{ width: '100%', height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={isNoData ? [{ name: "No Data", value: 100 }] : data}
            labelLine={false}
            outerRadius={80}
            fill="#8884d8"
            dataKey="value"
          >
            {isNoData ? (
              <Cell key={`cell-no-data`} fill="#d9d9d9" />
            ) : (
              data.map((entry: any, index: any) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))
            )}
          </Pie>
          {!isNoData && <Tooltip />}
          <Legend />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartGraph;
